module.exports = __webpack_public_path__ + "static/media/logo.332d74f5.png";